class CollectionPaginationNumbers extends HTMLElement
{
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', this.onClick);
    });
  }

  onClick(e) {
    e.preventDefault();
    const url = this.getAttribute('href');
    const productGrid = document.getElementById('ProductGridContainer');
    const pageNavigation = typeof FacetFiltersForm !== 'undefined'
      ? FacetFiltersForm.beginPageNavigation()
      : null;
    productGrid.querySelector('.collection').classList.add('loading');
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`Pagination request failed: ${response.status}`);
        return response.text();
      })
      .then(async (responseText) => {
        if (pageNavigation) {
          await pageNavigation.ready;
          if (!FacetFiltersForm.isCurrentPageNavigation(pageNavigation)) return;
          await FacetFiltersForm.waitForProductGridPosition(pageNavigation);
          if (!FacetFiltersForm.isCurrentPageNavigation(pageNavigation)) return;
        }
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const nextProductGrid = parsedHTML.getElementById('ProductGridContainer');
        const currentCollection = productGrid.querySelector('.collection');
        const nextCollection = nextProductGrid.querySelector('.collection');

        currentCollection.replaceWith(nextCollection);
        productGrid.dataset.resultsCount = nextProductGrid.dataset.resultsCount;
        const searchParams = url.split('?')[1];
        history.pushState({ searchParams, listingNavigation: 'pagination' }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
        if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.searchParamsPrev = searchParams;
      })
      .catch((error) => console.error(error))
      .finally(() => productGrid.querySelector('.collection')?.classList.remove('loading'));
  }

}

customElements.define('collection-pagination-numbers', CollectionPaginationNumbers);
